import React, { FC } from "react";
import clsx from "clsx";
import { SvgIconProps } from "@mui/material/SvgIcon";
import { processEnvServer } from "hooks/useSsrHooks";
import { getReqContext } from "utils/reqContext";

export const RHDropdownIcon: FC<SvgIconProps> = props => {
  const style = {
    fontSize: 12,
    ...props.style
  };
  const req = getReqContext();
  const isCartPage =
    (!processEnvServer
      ? location.pathname?.includes("/checkout/shopping_cart.jsp")
      : req?.path?.includes("/checkout/shopping_cart.jsp")) || false;
  return (
    <>
      {isCartPage ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          {...props}
          style={style}
          className={clsx([props.className, "rotate-90"])}
        >
          <path d="M5 2L11 8L5 14" stroke="black" stroke-width="0.75" />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          {...props}
          style={style}
          className={clsx([props.className, "rotate-90"])}
        >
          <path d="M5 2L11 8L5 14" stroke="black" stroke-width="0.75" />
        </svg>
      )}
    </>
  );
};

export default RHDropdownIcon;
